import { Injectable, inject } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { KeycloakEventLegacy, KeycloakService, KeycloakEventTypeLegacy } from 'keycloak-angular';
import { tap } from 'rxjs';

import { FeatureFlagsService } from '../../service/feature-flags.service';

@Injectable()
export class TogglesEffects {
  private featureFlagsService = inject(FeatureFlagsService);
  private keycloakService = inject(KeycloakService);

  setContext$ = createEffect(
    () =>
      this.keycloakService.keycloakEvents$.pipe(
        tap((keycloakEvent: KeycloakEventLegacy) => {
          const processLogin = (status: boolean) => {
            if (status) {
              this.featureFlagsService.updateContext({
                userId: instance?.tokenParsed?.sub,
                sessionId: instance?.sessionId,
                properties: {
                  roles: (instance?.tokenParsed?.realm_access?.roles ?? []).join(','),
                },
              });
            } else {
              this.featureFlagsService.updateContext({});
            }
          };

          const instance = this.keycloakService.getKeycloakInstance();

          if (KeycloakEventTypeLegacy.OnReady === keycloakEvent.type) {
            processLogin(this.keycloakService.isLoggedIn());
          } else if (
            KeycloakEventTypeLegacy.OnAuthRefreshError === keycloakEvent.type ||
            KeycloakEventTypeLegacy.OnAuthLogout === keycloakEvent.type
          ) {
            processLogin(false);
          } else if (
            KeycloakEventTypeLegacy.OnAuthSuccess === keycloakEvent.type ||
            KeycloakEventTypeLegacy.OnAuthRefreshSuccess === keycloakEvent.type
          ) {
            processLogin(true);
          }
        })
      ),
    { dispatch: false }
  );
}
